import Conversiones from "../../../../utils/conversiones";
import { FiltroGeneracionMasiva } from "../models/filtroGeneracionMasiva";
import { GenerarArchivoInput } from "../models/generarArchivoInput";
import { GenerarLiquidacionEndosoDto } from "../models/generarLiquidacionEndosoDto";
import { MutuoSeleccionadoGenMasiva } from "../models/mutuoSeleccionadoGenMasiva";
import { filtrarOperacionesGeneracionMasiva, generarArchivo, generarLiquidacion } from "../services/masivoService";

export default function UseGeneracionMasiva() {

    const obtenerEndososGeneracionMasiva = async (filtros: FiltroGeneracionMasiva) => {
        const response = await filtrarOperacionesGeneracionMasiva(filtros);
        return response;
    }

    const generarArchivoEndoso = async (mutuos: MutuoSeleccionadoGenMasiva[], fechaEndoso: Date, fechaOperacion: Date) => {
        const formatFechaEndoso : string = Conversiones.formatDateReverse(fechaEndoso, "-");
        const formatFechaOperacion : string = Conversiones.formatDateReverse(fechaOperacion, "-");

        const filtros : GenerarArchivoInput = {mutuosSeleccionados: mutuos, tipoArchivo: "NORMAL", 
                                                fechaEndoso: formatFechaEndoso, fechaOperacion: formatFechaOperacion};
        const response = await generarArchivo(filtros);
        return response;
    }

    const generarLiquidacionEndoso = async (mutuos: MutuoSeleccionadoGenMasiva[], fechaEmision: Date, rutInversionista: string) => {
        const formatFechaEndoso : string = Conversiones.formatDateReverse(fechaEmision, "-");
        const filtros : GenerarLiquidacionEndosoDto = {mutuos, fechaEmision: formatFechaEndoso, rutInversionista};
        const response = await generarLiquidacion(filtros);
        return response;
    }

    return {
        obtenerEndososGeneracionMasiva,
        generarArchivoEndoso,
        generarLiquidacionEndoso
    }
}